import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppIcon } from './WhatsAppIcon';
import { trackPurchase } from '../utils/metaPixel';
export const WhatsAppButton = () => {
  return <motion.a href="https://wa.me/5492996254007" target="_blank" rel="noopener noreferrer" onClick={trackPurchase} className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-whatsapp text-white rounded-full shadow-lg hover:bg-green-600 transition-colors" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} data-id="element-158">
      <motion.div animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute inset-0 rounded-full bg-whatsapp opacity-30" data-id="element-159" />
      <WhatsAppIcon className="w-8 h-8 relative z-10" data-id="element-160" />
    </motion.a>;
};